<template>
  <b-container fluid>
    
<!-- User Interface controls -->
    <template>
      <ListHeader />
    </template>
    <b-row>
      <b-col lg="6" class="my-4">
        <b-form-group
          label="Filter"
          label-for="filter-input"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="md"
          class="mb-0"
        >
          <b-input-group size="md">
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="search"
              placeholder="cerca"
            ></b-form-input>

            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col lg="6" class="my-4">
        <!-- <b-form-group
          v-model="sortDirection"
          label="Filter On"
          description="Leave all unchecked to filter on all data"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
          v-slot="{ ariaDescribedby }"
        > -->
        <b-form-group
          label="Filtra per"
          description="Eventi cliente (default)"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
          v-slot="{ ariaDescribedby }"
        >
          <b-form-checkbox-group
            :key="isCustomer"
            v-model="isCustomer"
            :aria-describedby="ariaDescribedby"
            class="mt-1"
          >
            <b-form-checkbox value="true" >cliente</b-form-checkbox>
            <b-form-checkbox value="false">gestore</b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </b-col>
    </b-row>

<!-- Main table element -->

    <b-table
      striped
      bordered
      outlined
      hover
      :head-variant="headVariant"
      :items="items"
      :fields="fields"
      :busy="isBusy"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      sort-icon-left
      stacked="md"
      show-empty
      :select-mode="selectMode"
      responsive="sm"
      ref="selectableTable"
      selectable
      @row-selected="onRowSelected"
      @filtered="onFiltered"
    >
      <template #table-busy>
        <div class="text-center text-light my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <!-- A custom formatted header cell for field 'name' -->
      <!-- <template #head(selected)>
        <input type="checkbox" class="lg" @click.stop="toggleSelectAll" name="selectAll" v-model="selectAll">
      </template> -->
      <template #cell(event)="row">
        {{ row.value.eventDesc }}
      </template>
      <!-- <template #cell(netPrice)="row">
        <span style="font-weight: 700: ">{{ row.item.netPrice | formatter }}</span>
      </template> -->

      <!-- <template #cell(actions)="row">
        <b-button size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1">
          Info modal
        </b-button>
        <b-button size="sm" @click="row.toggleDetails">
          {{ row.detailsShowing ? 'Hide' : 'Show' }} Details
        </b-button>
        <router-link :to="{name: 'edit_user', params: { id: row.item.id }}" class="icons">
              <span class="material-icons">edit</span>
              </router-link>
              <span @click.prevent="deleteUser(row.item.id)" class="material-icons">delete</span>
      </template> -->
    </b-table>
    
    <b-row>
      <b-col sm="5" md="6" class="my-1">
        <b-form-group
          label="Per page"
          label-for="per-page-select"
          label-cols-sm="6"
          label-cols-md="4"
          label-cols-lg="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
        >
          <b-form-select
            id="per-page-select"
            v-model="perPage"
            :options="pageOptions"
            size="sm"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col sm="7" md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>

    <!-- <p>
      <b-button size="sm" @click="selectAllRows">Select all</b-button>
      <b-button size="sm" @click="clearSelected">Clear selected</b-button>
    </p>
    <p>
      Selected Rows:<br>
      {{ selected }}
    </p> -->

<!-- Info modal -->

    <b-modal :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal">
      <pre>{{ infoModal.content }}</pre>
    </b-modal>
  </b-container>
</template>

<script>
  import { db } from '../../firebase/config.js';
  import ListHeader from '../ListHeader.vue';
  import moment from 'moment';
  import { mapGetters } from 'vuex';

  export default {
    /*filters: { 
      formatter: (value) => {
        return new Intl.NumberFormat('it-IT', {
          style: 'currency',
          currency: 'eur',
        }).format((value / 100).toFixed(2))
      }, 
    },*/
    data() {
      return {
        modes: ['multi', 'single', 'range'],
        params: {
          eventCode: ['ev01','ev11','ev90'],
          userRole: [1,2,3]
        },
        selectMode: 'multi',
        selected: [],
        selectAll: false,
        row: {},
        isBusy: true,
        headVariant: 'dark',
        isCustomer: true,
        items: [],
        userDogs: [],
        fields: [
          { key: 'datetime', label: 'Data - Ora', sortable: true, },
          { key: 'event', label: 'Evento',  sortable: false,  },
          { key: 'userFullName', label: 'Cognome Nome',  sortable: true,  },
          { key: 'uidCard', label: 'Card',  sortable: true,  },
          { key: 'uidSubsItem', label: 'Item',  sortable: false,  },
          { key: 'uidDogName', label: 'Nome cane',  sortable: false,  },
          /*{
            key: 'userRole',
            label: 'Gestore',
            // formatter: (value, key, item) => {
              formatter: (value) => {
              return value<3 ? '*' : ''
            },
            sortable: true,
            sortByFormatted: true,
            filterByFormatted: true
          },*/
          { key: 'netPrice', label: 'Ricavi & Consumi',  sortable: false, 
            formatter: (value) => {
              return new Intl.NumberFormat('it-IT', {
                style: 'currency',
                currency: 'eur',
              }).format((value / 100).toFixed(2)) || '-'
            },
            class: 'text-center' },
          { key: 'actions', label: 'Azioni' }
        ],
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, { value: 1000, text: "Tutte (1000)" }],
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        }
      }
    },
    created() {
      this.isBusy = true
      console.log(this.auth_user.claims.orgId)
      let eventsRef = null
      if(this.isCustomer) {
        eventsRef = db.collection('events')
        .where('orgId', '==', this.auth_user.claims.orgId)
        //.where('userRole', '==', 3)
        .where('userRole', 'in', this.params.userRole)
        //.where('eventCode', 'in', this.params.eventCode)
        .orderBy('datetime', 'desc') 
      } else {
        eventsRef = db.collection('events')
        .where('orgId', '==', this.auth_user.claims.orgId)
        .where('userRole', '<', 3)
        .orderBy('datetime', 'desc') 
      }
      /*eventsRef = db.collection('events')
        .where('orgId', '==', this.auth_user.claims.orgId)
        .orderBy('datetime', 'desc')
        .limit(1000)*/

      eventsRef.onSnapshot((snapshotChange) => {
        this.items = [];
        snapshotChange.forEach((doc) => {
          //console.log('event ->', doc.data())
          this.items.push({
            id: doc.id,
            event: {
              device: doc.data().device,
              eventCode: doc.data().eventCode,
              eventDesc: doc.data().eventDesc
            },
            datetime: moment(doc.data().datetime.seconds, 'X', true).format("YYYY.MM.DD - HH:mm"),
            uidCard: doc.data().uidCard,
            userRole: doc.data().userRole,
            userRef: doc.data().userRef,
            userFullName: doc.data().userFullName,
            uidSubsItem: doc.data().uidSubsItem,
            uidDogName: doc.data().uidDogName,
            netPrice: doc.data().netPrice || null,
            listPrice: doc.data().listPrice || null,
            totWash: doc.data().totWash || null,
          })
        });
        this.isBusy = false
        //console.debug(this.items)
      })
    },
    computed: {
      ...mapGetters({
        // map `this.auth_user` to `this.$store.getters.user` (logged authenticated/authorized user)
        auth_user: "user",
      }),
      sortOptions() {
        // Create an options list from our fields
        return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
      },
      totalRows() {
        return this.items.length
      }
    },
    methods: {
      forceRerender() {
        this.isCustomer = !this.isCustomer;  
      },
      onRowSelected(items) {
        this.selected = items
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows()
      },
      clearSelected() {
        this.$refs.selectableTable.clearSelected()
      },
      toggleSelectAll() {
        this.selectAll = !this.selectAll
        if(this.selectAll) {
          this.selectAllRows()
        } else {
          this.clearSelected()
        }
      },
      info(item, index, button) {
        this.infoModal.title = `Row index: ${index}`
        this.infoModal.content = JSON.stringify(item, null, 2)
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      },
      resetInfoModal() {
        this.infoModal.title = ''
        this.infoModal.content = ''
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      /*filterTable(row, filter) {
        //case Admin Roles
        if (row.userRole == '*' && !this.isCustomer) {
          return true;
          //case Customer Role
        } else if (row.userRole == '' && this.isCustomer) {
          return true;
        } else {
          return false;
        }
      },*/
    },
    filters: {
      formatDate: function(value) {
        if (!value) return
        else return moment(value, 'X', true).format("DD/MM/YY - HH:mm")
      }
    },
    components: {
      ListHeader,
    }
//});
  };
</script>